import BunkeyAPI from '../api/BunkeyAPI'
import {
  ASSET_ROOT_UPLOAD_GET_DATA,
  ASSET_ROOT_UPLOAD_GET_DATA_SUCCESS,
  ASSET_ROOT_UPLOAD_GET_DATA_FAILURE,
} from '../constants/assets-root-upload-types'
import store from '../store'
import { permissionsDefault } from '../utils'

export const getRootUpload = (
  workclient,
  folderselect,
  isFetching = true,
  data = []
) => {
  const user = store.getState().authUser.user

  return (dispatch) => {
    dispatch({
      type: ASSET_ROOT_UPLOAD_GET_DATA,
      payload: {
        isFetching,
        data,
      },
    })

    BunkeyAPI({
      url: `/clients/${workclient}/objects/${folderselect}`,
      method: 'GET',
      params: {limit:1000}
    })
      .then((resp) => {
        dispatch({
          type: ASSET_ROOT_UPLOAD_GET_DATA_SUCCESS,
          payload: {
            user,
            folderselect,
            data: resp.data.children
              .filter((r) => r.type === 'folder')
              .map((r) => {
                return {
                  _id: r._id,
                  type: 'bunker',
                  name: r.name,
                  group: r.group,
                  tagProtocol: r.tagProtocol,
                  longDescription: r.longDescription,
                  objectGroups: r.objectGroup,
                  matrix: permissionsDefault().map((def) => {
                    const exists = r.group.find((r) =>
                      r.permissions.find(
                        (item) =>
                          item.action === def.action && item.enabled === true
                      )
                    )
                    return {
                      action: def.action,
                      enabled: exists ? true : false,
                    }
                  }),
                  uuid: r.uuid,
                }
              }),
            headers: resp.headers,
          },
        })
      })
      .catch((err) => {
        dispatch({
          type: ASSET_ROOT_UPLOAD_GET_DATA_FAILURE,
          payload: err,
        })
      })
  }
}
